export const REPORT_SECTION_GRAY = '#6C757D'

/**
 * Orange section chrome on the customer report becomes this gray.
 * Green (and any other non-orange) company color stays as it is.
 * A missing color stays missing so the caller can keep its fallback.
 */
export const reportSectionColor = (color: string | undefined): string => {
  if (!color) return color || ''
  const hex = color.trim().toLowerCase()
  const match = /^#([0-9a-f]{6})$/.exec(hex)
  const digits = match?.[1]
  if (!digits) return color
  const value = parseInt(digits, 16)
  const red = (value >> 16) & 255
  const green = (value >> 8) & 255
  const blue = value & 255
  if (red >= 220 && green >= 60 && green <= 190 && blue <= 80) {
    return REPORT_SECTION_GRAY
  }
  return color
}
